import { Clock } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { UI_TRANSLATIONS } from "@/lib/i18n";

interface KioskActivityPromptProps {
  isVisible: boolean;
  onConfirm: () => void;
  remainingSeconds: number;
}

export const KioskActivityPrompt = ({
  isVisible,
  onConfirm,
  remainingSeconds
}: KioskActivityPromptProps) => {
  const { language } = useLanguage();
  const translations = UI_TRANSLATIONS[language];

  if (!isVisible) return null;

  return (
    <div className="kiosk-prompt-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="kiosk-prompt-box">
        <Clock className="kiosk-prompt-icon" size={64} />
        <h2 className="kiosk-prompt-title">{translations.stillHere}</h2>
        <p className="kiosk-prompt-countdown">
          {translations.secondsRemaining(remainingSeconds)}
        </p>
        <button 
          className="kiosk-prompt-button"
          onClick={onConfirm}
          type="button"
        >
          {translations.confirmStillHere}
        </button>
      </div>
    </div>
  );
};
